import { FarIcons } from '@playbooks/icons';
import { StructuralIcon } from '@playbooks/ui/components/structural-icon';

import {
	ComposerActionHeader,
	ComposerActionRow,
	ComposerActionSection,
} from 'components/composer/composer-actions-components';
import { FlowBody } from 'utils/flow';

const ComposerActionsComposer = ({ delivery, permissions, canManage = false, onMemory, onPrev, onView }) => (
	<>
		<ComposerActionHeader title='Composer' onPrev={onPrev} />
		<FlowBody>
			<ComposerActionSection>
				<ComposerActionRow
					icon={FarIcons.farBarsStaggered}
					label='Delivery'
					value={delivery}
					onClick={() => onView('delivery')}
				/>
				<ComposerActionRow
					icon={FarIcons.farShield}
					label='Permissions'
					value={permissions}
					onClick={() => onView('permissions')}
				/>
				<ComposerActionRow
					icon={FarIcons.farComment}
					label='Memory'
					value={canManage ? 'Edit' : 'View'}
					trailing={
						<StructuralIcon
							data-icon='inline-end'
							icon={canManage ? FarIcons.farPencil : FarIcons.farEye}
							className='size-3 text-foreground-body'
							aria-hidden
						/>
					}
					onClick={onMemory}
				/>
			</ComposerActionSection>
		</FlowBody>
	</>
);

export { ComposerActionsComposer };
